import React, { Component } from "react";
import {
  Row,
  Col,
  Form,
  Button,
  Card,
  Input,
  message,
  Select,
  Spin,
} from "antd";
import axios from "services/axios";

const FormItem = Form.Item;
const { Option } = Select;

class NewCarAreaCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      bohUsers: [],
      pricingAreas: [],
      isLoading: false,
    };
  }

  componentDidMount() {
    this.fetchAreaPricing();
    this.fetchBOH();
  }

  async fetchAreaPricing() {
    const {
      data: { areas },
    } = await axios.get(`/misc/area-pricing`);
    this.setState({ pricingAreas: areas });
  }

  async fetchBOH() {
    const {
      data: { bohUsers },
    } = await axios.get(`/misc/boh-users`);
    this.setState({ bohUsers });
  }

  async createNewCarArea(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll((err, values) => {
      this.setState({ isLoading: true });
      if (!err) {
        axios
          .post(`/admin-panel/new-car-area`, values)
          .then(result => {
            message.success(`Berhasil menambah Area ${values.name}`);
            this.props.history.push(`/home/new-car-area`);
          })
          .catch(err => {
            this.errorMessage(err);
          });
      }
      this.setState({ isLoading: false });
    });
  }

  callback(key, props) {
    props.form.resetFields();
  }

  errorMessage(e) {
    if (e.response) {
      if (e.response.data || e.response.message) {
        message.error(
          e.response.data.message || e.response.message || e.response.data
        );
      } else {
        message.error("Error Create Area");
      }
    } else {
      message.error("Error Create Area");
    }
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Card title="Create New Car Area">
        <Spin
          tip="Sedang menambahkan Area Baru"
          spinning={this.state.isLoading}>
          <Form onSubmit={e => this.createNewCarArea(e)}>
            <FormItem label="Area">
              {getFieldDecorator("name", {
                rules: [{ required: true, message: "Area wajib diisi" }],
              })(<Input />)}
            </FormItem>

            <Row type="flex" justify="end">
              <Col>
                <Button htmlType="submit" type="primary">
                  Create
                </Button>
              </Col>
            </Row>
          </Form>
        </Spin>
      </Card>
    );
  }
}

export default Form.create()(NewCarAreaCreate);



// WEBPACK FOOTER //
// src/components/Dashboard/Area/NewCarArea/NewCarAreaCreate.js